/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisputePenaltyInput
 */
export interface DisputePenaltyInput {
    /**
     * 
     * @type {string}
     * @memberof DisputePenaltyInput
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputePenaltyInput
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputePenaltyInput
     */
    description?: string;
}

/**
 * Check if a given object implements the DisputePenaltyInput interface.
 */
export function instanceOfDisputePenaltyInput(value: object): value is DisputePenaltyInput {
    return true;
}

export function DisputePenaltyInputFromJSON(json: any): DisputePenaltyInput {
    return DisputePenaltyInputFromJSONTyped(json, false);
}

export function DisputePenaltyInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputePenaltyInput {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function DisputePenaltyInputToJSON(json: any): DisputePenaltyInput {
    return DisputePenaltyInputToJSONTyped(json, false);
}

export function DisputePenaltyInputToJSONTyped(value?: DisputePenaltyInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'type': value['type'],
        'description': value['description'],
    };
}

